// src/components/pwa/NotificationPermissionButton.jsx
import React from 'react';
import { Bell } from '@phosphor-icons/react';
import { useAuth } from '../../context/AuthContext';
import { saveFcmToken } from '../../api/api';
import { useNotificationPermission } from '../../hooks/useNotificationPermission';
import { isIos, isStandaloneDisplay } from '../../services/NotificationService';

// Shared control used both on the Profile page and inside the
// EnableNotificationsBanner.
const NotificationPermissionButton = ({ onGranted, onDenied, className = '' }) => {
  const { user } = useAuth();
  const { status, busy, error, enable } = useNotificationPermission({
    userId: user?.uid,
    saveToken: saveFcmToken,
  });

  const handleClick = async () => {
    const result = await enable();
    if (result === 'granted') {
      onGranted && onGranted();
    } else if (result !== 'error') {
      onDenied && onDenied();
    }
  };

  if (status === 'granted') {
    return (
      <span className={`inline-flex items-center gap-1.5 ${className}`}>
        <Bell size={16} weight="bold" /> Notifications enabled
      </span>
    );
  }

  if (isIos() && !isStandaloneDisplay()) {
    return (
      <span className={className}>
        Add Zimzo to your Home Screen to enable notifications.
      </span>
    );
  }

  if (status === 'denied') {
    return (
      <span className={className}>
        Notifications are blocked. Enable them in your device settings.
      </span>
    );
  }

  if (status === 'unsupported') {
    return null;
  }

  return (
    <div>
      <button
        type="button"
        className={className || 'text-amber-600 font-medium hover:text-amber-700 hover:underline'}
        disabled={busy}
        onClick={handleClick}
      >
        {busy ? 'Enabling…' : 'Enable Notifications'}
      </button>
      {error && <p className="text-sm text-red-600 mt-1">{error}</p>}
    </div>
  );
};

export default NotificationPermissionButton;
